import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { jsx } from 'react/jsx-runtime';
import { getValidFileExtensions, MAX_FILE_SIZE, UploadStatus } from '@hub-la/fe-asset';

const Input = ({
  onChange
}) => {
  const validExtensions = getValidFileExtensions('videoAsset');
  return jsx("input", {
    type: "file",
    "data-testid": "input",
    "data-max-size": MAX_FILE_SIZE,
    multiple: true,
    accept: validExtensions,
    style: {
      display: 'none',
      margin: 0,
      padding: 0
    },
    onChange: e => {
      if (e.target.files === null) return;
      const files = Array.from(e.target.files).map(file => ({
        file,
        status: UploadStatus.NO_CALLED
      }));
      onChange(state => [...state, ...files]);
    }
  });
};

export { Input };
